/** German strings for the menu wizard, lobby and controls. Keys are the exact English source text. */
export const DE_MENU: Readonly<Record<string, string>> = {
  // Menu frame / step rail
  'DRIVER': 'FAHRER',
  'Name + steering': 'Name + Lenkung',
  'GARAGE': 'GARAGE',
  'Car + livery': 'Auto + Lackierung',
  'PLAY': 'SPIELEN',
  'Join · host · offline': 'Beitreten · hosten · offline',
  'LOBBY': 'LOBBY',
  'Track + grid': 'Strecke + Grid',
  'RACE': 'RENNEN',
  'Lights out': 'Lichter aus',
  'Setup progress': 'Einrichtungsfortschritt',
  'Go to driver': 'Zum Fahrer',
  'Go to garage': 'Zur Garage',
  'Go to play': 'Zum Spielmodus',
  'Go to lobby': 'Zur Lobby',
  'Race control log': 'Rennleitungs-Log',
  'LOG': 'LOG',
  'Recent race control messages': 'Letzte Meldungen der Rennleitung',
  'Sound and music': 'Sound und Musik',
  'SOUND': 'SOUND',
  'INSTALL ↘': 'INSTALLIEREN ↘',
  'ONLINE': 'ONLINE',
  'OFFLINE READY': 'OFFLINE BEREIT',
  'Edit driver profile': 'Fahrerprofil bearbeiten',
  'LV {level} · {car}': 'LV {level} · {car}',
  'BACK': 'ZURÜCK',
  'NEXT': 'WEITER',

  // Driver step
  'KEYBOARD': 'TASTATUR',
  'CONTROLLER': 'CONTROLLER',
  'TOUCH': 'TOUCH',
  'TILT': 'NEIGEN',
  'WASD / arrows, fully remappable': 'WASD / Pfeile, frei belegbar',
  'Connected': 'Verbunden',
  'Press any button to connect': 'Drück eine Taste zum Verbinden',
  'On-screen thumb controls': 'Daumensteuerung auf dem Display',
  'Steer by tilting your phone': 'Lenk durch Neigen deines Handys',
  "YOU'RE INVITED": 'DU BIST EINGELADEN',
  "{name}'s lobby · {track}": 'Lobby von {name} · {track}',
  'Set up your driver and car, then you join straight in.': 'Richte Fahrer und Auto ein, dann bist du direkt dabei.',
  'STEP 2 OF 6': 'SCHRITT 2 VON 6',
  "WHO'S": 'WER',
  'DRIVING?': 'FÄHRT?',
  'Your callsign shows on the grid, the leaderboard and in every lobby. It stays on this device — no account needed.': 'Dein Rufname steht in der Startaufstellung, in der Rangliste und in jeder Lobby. Er bleibt auf diesem Gerät – ganz ohne Konto.',
  'CALLSIGN': 'RUFNAME',
  'YOUR NAME': 'DEIN NAME',
  'Suggest a callsign': 'Rufname vorschlagen',
  '2–18 characters · looks good': '2–18 Zeichen · passt',
  'Use at least two characters': 'Mindestens zwei Zeichen',
  'COCKPIT VIEW': 'COCKPIT-ANSICHT',
  "Race from the driver's seat. Switch any time with the wheel button, top right.": 'Fahr vom Fahrersitz aus. Wechsle jederzeit über den Lenkrad-Button oben rechts.',
  "Race from the driver's seat. Switch any time with the camera key.": 'Fahr vom Fahrersitz aus. Wechsle jederzeit mit der Kamerataste.',
  'STEERING': 'LENKUNG',
  'Used for every race · change any time from the pause menu': 'Gilt für jedes Rennen · jederzeit im Pausenmenü änderbar',
  'Steering input': 'Lenkeingabe',
  'Not available on this device': 'Auf diesem Gerät nicht verfügbar',
  'DETECTED': 'ERKANNT',
  'HANDLING ASSIST': 'FAHRHILFE',
  'Handling assist': 'Fahrhilfe',
  'ARCADE': 'ARCADE',
  'Forgiving near the limit. Great for touch and first races.': 'Verzeiht viel im Grenzbereich. Ideal für Touch und erste Rennen.',
  'BALANCED': 'AUSGEWOGEN',
  'Subtle help that stays out of the way.': 'Dezente Hilfe, die dich nicht bremst.',
  'PRO': 'PRO',
  'Raw input. Every correction is yours.': 'Pure Eingabe. Jede Korrektur kommt von dir.',
  'CORNER COACH': 'KURVEN-COACH',
  'Brake and lift cues before demanding corners.': 'Brems- und Lupf-Hinweise vor kniffligen Kurven.',
  'Keyboard map': 'Tastenbelegung',
  'Rebind {action}, currently {key}': '{action} neu belegen, aktuell {key}',
  'or': 'oder',
  'Click a key to rebind it. Esc cancels. Keys already in use swap places.': 'Klick auf eine Taste, um sie neu zu belegen. Esc bricht ab. Belegte Tasten tauschen die Plätze.',
  'RESET KEYS': 'TASTEN ZURÜCKSETZEN',
  'CONTROLLER CONNECTED': 'CONTROLLER VERBUNDEN',
  'NO CONTROLLER YET': 'NOCH KEIN CONTROLLER',
  'Triggers drive, left stick steers. Full remapping lives in the pause menu.': 'Trigger für Gas und Bremse, linker Stick lenkt. Komplette Belegung im Pausenmenü.',
  'Connect a pad and press any button — it is picked up instantly.': 'Schließ ein Gamepad an und drück eine Taste – es wird sofort erkannt.',
  'STICK DEAD ZONE': 'STICK-TOTZONE',
  'STEERING RESPONSE': 'LENKANSPRACHE',
  'VIBRATION': 'VIBRATION',
  'QUICK': 'DIREKT',
  'PRECISE': 'PRÄZISE',
  'LINEAR': 'LINEAR',
  'THUMB LAYOUT': 'DAUMEN-LAYOUT',
  'Swap steering and pedals for left-handed play.': 'Tauscht Lenkung und Pedale für Linkshänder.',
  'STANDARD': 'STANDARD',
  'LEFT-HANDED': 'LINKSHÄNDER',
  'BUTTON SIZE': 'BUTTONGRÖSSE',
  'AUTO-GAS': 'AUTO-GAS',
  'Keeps accelerating until you brake.': 'Gibt Gas, bis du bremst.',
  'HAPTICS': 'HAPTIK',
  'Short pulses on supported phones.': 'Kurze Vibrationen auf unterstützten Handys.',
  'STEERING RANGE': 'LENKBEREICH',
  'NEUTRAL DEAD ZONE': 'TOTZONE MITTE',
  'TILT RESPONSE': 'NEIGE-ANSPRACHE',
  'Precise softens small movements; Agile reacts earlier.': 'Präzise dämpft kleine Bewegungen, Agil reagiert früher.',
  'AGILE': 'AGIL',
  'CENTRE': 'MITTE',
  'WAKE THE SENSOR': 'SENSOR AKTIVIEREN',
  'One tap lets the browser share motion data. You only do this once.': 'Ein Tipp, und der Browser teilt die Bewegungsdaten. Nur einmal nötig.',
  'LISTENING…': 'WARTE AUF DATEN…',
  'Hold your phone like a steering wheel and give it a little tilt.': 'Halt dein Handy wie ein Lenkrad und neig es ein wenig.',
  'SENSOR LIVE': 'SENSOR AKTIV',
  'Hold it how you want to race and tap SET CENTRE.': 'Halt es so, wie du fahren willst, und tippe auf MITTE SETZEN.',
  'SENSOR READY': 'SENSOR BEREIT',
  'NO SENSOR DATA': 'KEINE SENSORDATEN',
  'This browser did not deliver motion data. Touch controls take over in the race.': 'Dieser Browser liefert keine Bewegungsdaten. Im Rennen übernimmt die Touch-Steuerung.',
  'MOTION BLOCKED': 'BEWEGUNG BLOCKIERT',
  'Allow motion & orientation for this site in the browser settings, then try again.': 'Erlaube Bewegung & Ausrichtung für diese Seite in den Browser-Einstellungen und versuch es erneut.',
  'NEEDS HTTPS': 'HTTPS NÖTIG',
  'Motion sensors only work over a secure connection. Touch controls stay available.': 'Bewegungssensoren laufen nur über eine sichere Verbindung. Touch-Steuerung bleibt verfügbar.',
  'NO MOTION SENSOR': 'KEIN BEWEGUNGSSENSOR',
  'This device does not report tilt. Touch controls are the way to go.': 'Dieses Gerät meldet keine Neigung. Nimm am besten die Touch-Steuerung.',
  'TRY AGAIN': 'NOCHMAL VERSUCHEN',
  'ENABLE MOTION SENSOR': 'BEWEGUNGSSENSOR AN',
  'SET CENTRE': 'MITTE SETZEN',
  'USE TOUCH INSTEAD': 'LIEBER TOUCH',
  '{percent}% LEFT': '{percent}% LINKS',
  '{percent}% RIGHT': '{percent}% RECHTS',
  '{key} is reserved for menus': '{key} ist für Menüs reserviert',
  'PRESS A KEY…': 'TASTE DRÜCKEN…',
  'CENTRE SET': 'MITTE GESETZT',
  'Keyboard map reset to defaults': 'Tastenbelegung auf Standard zurückgesetzt',

  // Keyboard actions
  'ACCELERATE': 'GAS GEBEN',
  'BRAKE / REVERSE': 'BREMSE / RÜCKWÄRTS',
  'STEER LEFT': 'LINKS LENKEN',
  'STEER RIGHT': 'RECHTS LENKEN',
  'DRIFT': 'DRIFT',
  'NITRO': 'NITRO',
  'RECOVER': 'ZURÜCKSETZEN',
  'CAMERA': 'KAMERA',
  'BANK HEAT': 'HEAT SICHERN',
  'TURRET LEFT': 'TURM LINKS',
  'TURRET RIGHT': 'TURM RECHTS',
  'FIRE': 'FEUER',

  // Key caps (printed legends on German keyboards)
  'SPACE': 'LEERTASTE',
  'CTRL': 'STRG',
  'R-CTRL': 'R-STRG',
  'DEL': 'ENTF',
  'INS': 'EINFG',
  'HOME': 'POS1',
  'END': 'ENDE',
  'PG UP': 'BILD ↑',
  'PG DN': 'BILD ↓',

  // Garage step
  'Selected vehicle': 'Gewähltes Fahrzeug',
  'Previous vehicle': 'Vorheriges Fahrzeug',
  'Vehicles': 'Fahrzeuge',
  'Leave the ghost challenge to change vehicle': 'Verlass die Ghost-Challenge, um das Fahrzeug zu wechseln',
  'Next vehicle': 'Nächstes Fahrzeug',
  '⟲ DRAG TO ROTATE': '⟲ ZIEHEN ZUM DREHEN',
  '← → TO BROWSE': '← → ZUM BLÄTTERN',
  'Tuning': 'Tuning',

  // Play step
  'STEP 4 OF 6': 'SCHRITT 4 VON 6',
  'WHERE DO YOU': 'WO WILLST DU',
  'WANT TO RACE?': 'FAHREN?',
  'MULTIPLAYER': 'MULTIPLAYER',
  'JOIN': 'BEITRETEN',
  'Jump into a public lobby, or paste a private invite link from a friend.': 'Spring in eine öffentliche Lobby oder füg den privaten Einladungslink eines Freundes ein.',
  'INVITE LINK': 'EINLADUNGSLINK',
  'Paste the whole link — it contains the private key.': 'Füg den ganzen Link ein – er enthält den privaten Schlüssel.',
  'HOST': 'HOST',
  'Open your own lobby. Pick track, rules and AI rivals together with your crew — everyone sees changes live.': 'Eröffne deine eigene Lobby. Wähl Strecke, Regeln und KI-Gegner mit deiner Crew – alle sehen Änderungen live.',
  'Up to 6 drivers + AI rivals': 'Bis zu 6 Fahrer + KI-Gegner',
  'Private link by default, go public any time': 'Standardmäßig privater Link, jederzeit öffentlich schaltbar',
  'Kick, ban and force start as host': 'Als Host kicken, bannen und Start erzwingen',
  'Hosting needs a connection to race control': 'Zum Hosten brauchst du eine Verbindung zur Rennleitung',
  'HOST A LOBBY': 'LOBBY HOSTEN',
  'SINGLE PLAYER': 'EINZELSPIELER',
  'OFFLINE': 'OFFLINE',
  'Race AI rivals on this device. No network, no waiting — the full simulation runs locally.': 'Fahr gegen KI-Gegner auf diesem Gerät. Kein Netz, kein Warten – die volle Simulation läuft lokal.',
  'Every track, format and weather': 'Jede Strecke, jedes Format, jedes Wetter',
  'Rookie, Sport or Pro per rival': 'Rookie, Sport oder Pro pro Gegner',
  'Arcade Lab rule sets': 'Arcade-Lab-Regelsets',
  'RACE OFFLINE': 'OFFLINE FAHREN',
  'EVENTS': 'EVENTS',
  'Curated offline races · open in the lobby so you can still tweak them': 'Kuratierte Offline-Rennen · öffnen in der Lobby, damit du sie noch anpassen kannst',
  'CAREER': 'KARRIERE',
  'LOCAL STREET CAREER': 'LOKALE STRASSENKARRIERE',
  'OPEN': 'ÖFFNEN',
  'START FRESH': 'NEU ANFANGEN',
  'DATA ON THIS DEVICE': 'DATEN AUF DIESEM GERÄT',
  'Deletes everything NIGHTSHIFT stores on this device — driver, cars and liveries, lobby setups, settings and key bindings, career, ghosts and saved races — then restarts at step 1.': 'Löscht alles, was NIGHTSHIFT auf diesem Gerät speichert – Fahrer, Autos und Lackierungen, Lobby-Setups, Einstellungen und Tastenbelegung, Karriere, Ghosts und gespeicherte Rennen – und startet neu bei Schritt 1.',
  'RESET LOCAL DATA': 'LOKALE DATEN LÖSCHEN',
  'You are offline. Public lobbies appear here once you reconnect.': 'Du bist offline. Öffentliche Lobbys erscheinen hier, sobald du wieder verbunden bist.',
  'Looking for public lobbies…': 'Suche öffentliche Lobbys…',
  'No public lobbies right now.': 'Gerade keine öffentlichen Lobbys.',
  'Host one and switch it to public — it shows up here for everyone.': 'Hoste eine und stell sie auf öffentlich – dann taucht sie hier für alle auf.',
  "{name}'s lobby": 'Lobby von {name}',
  '+{n} AI': '+{n} KI',
  'DRIVERS': 'FAHRER',
  'FULL': 'VOLL',
  'RACING': 'IM RENNEN',
  'Checking the invitation…': 'Einladung wird geprüft…',
  'This race is already running — you can watch it live.': 'Dieses Rennen läuft schon – du kannst live zuschauen.',
  'This lobby is full right now.': 'Diese Lobby ist gerade voll.',
  '{players} / {max} drivers · {npcs} AI rivals': '{players} / {max} Fahrer · {npcs} KI-Gegner',
  'Private lobby': 'Private Lobby',
  'WATCH LIVE ◎': 'LIVE ZUSEHEN ◎',
  'JOIN LOBBY': 'LOBBY BEITRETEN',
  'Dismiss invitation': 'Einladung verwerfen',
  'DAWN': 'MORGEN',
  'DAY': 'TAG',
  'SUNSET': 'ABEND',
  'NIGHT': 'NACHT',
  'CLEAR': 'KLAR',
  'HAZE': 'DUNST',
  'RAIN': 'REGEN',
  'SAND': 'SAND',
  'SNOW': 'SCHNEE',

  // Lobby
  'First across the line after every lap wins.': 'Wer nach allen Runden zuerst über die Linie fährt, gewinnt.',
  'One flat-out lap. No second chances.': 'Eine Runde Vollgas. Keine zweite Chance.',
  'Solo against the clock, a ghost and medal targets.': 'Solo gegen die Uhr, einen Ghost und Medaillenzeiten.',
  'Drifts, drafts and near misses score. Highest style wins.': 'Drifts, Windschatten und knappe Manöver bringen Punkte. Der meiste Style gewinnt.',
  'Last place drops out at the end of every lap.': 'Der Letzte fliegt am Ende jeder Runde raus.',
  'Interceptors escalate each lap. Bank your heat or push on.': 'Die Verfolger legen jede Runde nach. Sichere deine Heat oder geh aufs Ganze.',
  'Take down the marked rival. Contact is always on.': 'Schalte den markierten Rivalen aus. Kontakt ist immer an.',
  'ROOKIE': 'ROOKIE',
  'SPORT': 'SPORT',
  '{mode} needs {n} racers — add a rival': '{mode} braucht {n} Fahrer – füg einen Gegner hinzu',
  'Add at least one rival or pick Time Trial': 'Füg mindestens einen Gegner hinzu oder wähl Zeitfahren',
  'OFFLINE SESSION': 'OFFLINE-SESSION',
  "{name}'S LOBBY": 'LOBBY VON {name}',
  'PRIVATE LOBBY': 'PRIVATE LOBBY',
  'Building the circuit and warming up the grid…': 'Strecke wird gebaut, das Feld wärmt sich auf…',
  'Loading the track in the background…': 'Strecke lädt im Hintergrund…',
  'Ready when you are — the grid releases instantly.': 'Bereit, wenn du es bist – das Feld startet sofort.',
  'Waiting for {names}': 'Warte auf {names}',
  'You are ready — the race starts when everyone is.': 'Du bist bereit – das Rennen startet, sobald alle es sind.',
  'Solo for now — share the invite, or ready up to race the AI.': 'Noch allein – teil die Einladung oder melde dich bereit für die KI.',
  'Everyone else is ready. Confirm to launch.': 'Alle anderen sind bereit. Bestätige zum Start.',
  'STEP 5 · SOLO VS AI': 'SCHRITT 5 · SOLO GEGEN KI',
  'STEP 5 · MULTIPLAYER LOBBY': 'SCHRITT 5 · MULTIPLAYER-LOBBY',
  'Public lobbies appear in everyone’s lobby browser': 'Öffentliche Lobbys erscheinen im Lobby-Browser aller Spieler',
  'Only the host can change visibility': 'Nur der Host kann die Sichtbarkeit ändern',
  'VISIBILITY': 'SICHTBARKEIT',
  'PUBLIC': 'ÖFFENTLICH',
  'PRIVATE · LINK ONLY': 'PRIVAT · NUR PER LINK',
  'Change car and livery (G)': 'Auto und Lackierung ändern (G)',
  'LEAVE': 'VERLASSEN',
  'YOU ARE THE HOST': 'DU BIST DER HOST',
  'SET BY THE HOST · LIVE': 'VOM HOST FESTGELEGT · LIVE',
  'HEAT LVLS': 'HEAT-STUFEN',
  'LAP': 'RUNDE',
  'LAPS': 'RUNDEN',
  'KM': 'KM',
  'CORNERS': 'KURVEN',
  'ALT ROUTES': 'ALT. ROUTEN',
  'CHANGE TRACK': 'STRECKE ÄNDERN',
  'TRACK': 'STRECKE',
  'FORMAT': 'FORMAT',
  'Event format': 'Eventformat',
  'HEAT LEVELS': 'HEAT-STUFEN',
  'Laps': 'Runden',
  'One lap fewer': 'Eine Runde weniger',
  'One more lap': 'Eine Runde mehr',
  'TRACK DEFAULT': 'STRECKEN-STANDARD',
  'FIXED BY FORMAT': 'VOM FORMAT FIXIERT',
  'DRIVER SLOTS': 'FAHRERPLÄTZE',
  'Human driver slots': 'Plätze für menschliche Fahrer',
  'Fewer driver slots': 'Weniger Fahrerplätze',
  'More driver slots': 'Mehr Fahrerplätze',
  '{n} JOINED': '{n} DABEI',
  'TIME OF DAY': 'TAGESZEIT',
  'Time of day': 'Tageszeit',
  'WEATHER': 'WETTER',
  'NO ATMOSPHERE': 'KEINE ATMOSPHÄRE',
  'The Moon has no weather — always a black sky and a hard sun.': 'Der Mond hat kein Wetter – immer schwarzer Himmel und gleißende Sonne.',
  'Weather': 'Wetter',
  'ROAD TRAFFIC': 'STRASSENVERKEHR',
  'Light civilian traffic that rivals plan around.': 'Leichter Zivilverkehr, auf den sich die Gegner einstellen.',
  'COLLISIONS': 'KOLLISIONEN',
  'Off turns every car into a ghost. Walls stay solid.': 'Aus macht jedes Auto zum Ghost. Wände bleiben hart.',
  'STRICT RESYNC': 'STRIKTER RESYNC',
  'Server position always wins after a reconnect.': 'Nach einem Reconnect gilt immer die Serverposition.',
  'ARCADE LAB': 'ARCADE LAB',
  'Playful physics. Career records are paused.': 'Verspielte Physik. Karriere-Rekorde pausieren.',
  'STARTING GRID': 'STARTAUFSTELLUNG',
  '{n} CAR ON GRID': '{n} AUTO IM FELD',
  '{n} CARS ON GRID': '{n} AUTOS IM FELD',
  '{ready} / {total} READY': '{ready} / {total} BEREIT',
  'OPEN SLOT': 'FREIER PLATZ',
  'Share the invite link': 'Teil den Einladungslink',
  'Waiting for a driver': 'Warte auf einen Fahrer',
  'AI RIVALS': 'KI-GEGNER',
  'TIME TRIAL IS SOLO': 'ZEITFAHREN IST SOLO',
  '+ ADD RIVAL': '+ GEGNER',
  'FILL GRID': 'FELD FÜLLEN',
  'Time Trial puts you alone on the road with your personal ghost and medal targets.': 'Im Zeitfahren bist du allein auf der Strecke – mit deinem Ghost und Medaillenzeiten.',
  'No AI rivals yet. Add a few to fill the grid — each one can have its own difficulty.': 'Noch keine KI-Gegner. Füg ein paar hinzu, um das Feld zu füllen – jeder kann seine eigene Schwierigkeit haben.',
  'No AI rivals on this grid.': 'Keine KI-Gegner in diesem Feld.',
  'INVITE LINK · ALSO LISTED PUBLICLY': 'EINLADUNGSLINK · AUCH ÖFFENTLICH GELISTET',
  'Invite link': 'Einladungslink',
  'COPY': 'KOPIEREN',
  'QR + SHARE ↗': 'QR + TEILEN ↗',
  'OFFLINE · THIS DEVICE ONLY': 'OFFLINE · NUR DIESES GERÄT',
  'No network needed. Progress is saved locally.': 'Kein Netz nötig. Fortschritt wird lokal gespeichert.',
  'Start now — every other driver is ready': 'Jetzt starten – alle anderen Fahrer sind bereit',
  'FORCE START': 'START ERZWINGEN',
  'START NOW': 'JETZT STARTEN',
  'CANCEL': 'ABBRECHEN',
  'READY': 'BEREIT',
  'LAUNCHING…': 'STARTET…',
  'LOADING TRACK…': 'STRECKE LÄDT…',
  'READY · CANCEL': 'BEREIT · ABBRECHEN',
  'START {mode}': '{mode} STARTEN',
  'I’M READY': 'ICH BIN BEREIT',
  'RECONNECTING': 'VERBINDET NEU',
  'NOT READY': 'NICHT BEREIT',
  'Kick {name}': '{name} kicken',
  'CONFIRM KICK': 'KICK BESTÄTIGEN',
  'KICK': 'KICKEN',
  'Ban {name}': '{name} bannen',
  'CONFIRM BAN': 'BANN BESTÄTIGEN',
  'BAN': 'BANNEN',
  'YOU': 'DU',
  'RIVAL BOSS': 'RIVALEN-BOSS',
  'CAR ASSIGNED AT LAUNCH': 'AUTO WIRD BEIM START ZUGETEILT',
  'GRIP': 'GRIP',
  'BULLY': 'RÜPEL',
  'SPRINTER': 'SPRINTER',
  'TRICKSTER': 'TRICKSER',
  'Difficulty of {name}': 'Schwierigkeit von {name}',
  'Remove {name}': '{name} entfernen',
  'NEW': 'NEU',
  'New circuit': 'Neue Strecke',
  'LOW G · {percent}%': 'LOW G · {percent} %',
  'Reduced gravity: longer, floatier jumps': 'Reduzierte Schwerkraft: längere, schwebende Sprünge',
  '{n} JUMPS': '{n} SPRÜNGE',
  '{n} ramps on every lap': '{n} Rampen pro Runde',
  'LOOP': 'LOOPING',
  'Vertical stunt loop': 'Vertikaler Stunt-Looping',
  'HOST CONTROL': 'HOST-STEUERUNG',
  'CHOOSE A TRACK': 'STRECKE WÄHLEN',
  'CLOSE': 'SCHLIESSEN',
  'Close track list': 'Streckenliste schließen',
  '{laps} LAPS · {km} KM': '{laps} RUNDEN · {km} KM',

  // Controls settings
  'STEER': 'LENKEN',
  'FIRE (TANK)': 'FEUER (PANZER)',
  'TURRET (TANK)': 'TURM (PANZER)',
  'PAUSE MENU': 'PAUSENMENÜ',
  'PUSH THE STICK LEFT': 'STICK NACH LINKS DRÜCKEN',
  'SQUEEZE THE GAS TRIGGER': 'GAS-TRIGGER DRÜCKEN',
  'SQUEEZE THE BRAKE TRIGGER': 'BREMS-TRIGGER DRÜCKEN',
  'PRESS A BUTTON': 'TASTE DRÜCKEN',
  'Controller map reset to defaults': 'Controller-Belegung auf Standard zurückgesetzt',
  '{family} CONTROLLER // {state}': '{family}-CONTROLLER // {state}',
  'CUSTOM MAP': 'EIGENE BELEGUNG',
  'LEGACY MAP': 'ALT-BELEGUNG',
  'NO CONTROLLER DETECTED': 'KEIN CONTROLLER ERKANNT',
  'no vibration support in this browser': 'keine Vibration in diesem Browser',
  'rebind each action below to finish setup': 'belege unten jede Aktion neu, um die Einrichtung abzuschließen',
  'Connect a controller and press any button. Wired and Bluetooth pads are detected automatically.': 'Schließ einen Controller an und drück eine Taste. Kabel- und Bluetooth-Pads werden automatisch erkannt.',
  'QUICK {value}': 'DIREKT {value}',
  'PRECISE {value}': 'PRÄZISE {value}',
  'OFF': 'AUS',
  'REBIND': 'NEU BELEGEN',
  'FIXED': 'FEST',
  'CONNECT PAD': 'PAD VERBINDEN',
  'ESC / WAIT TO CANCEL': 'ESC / WARTEN ZUM ABBRECHEN',
  'PRESS A KEY': 'TASTE DRÜCKEN',
  'LEFT STICK': 'LINKER STICK',
  'RIGHT STICK': 'RECHTER STICK',
  'AXIS {n}': 'ACHSE {n}',
  '{family} controller layout': '{family}-Controller-Layout',

  // Gamepad prompt bar
  'ADJUST': 'ANPASSEN',
  'TOGGLE': 'UMSCHALTEN',
  'SELECT': 'AUSWÄHLEN',
  'SECTION': 'BEREICH',
};
